// src/utils/skuUtils.js

// "Green", "Extra Large", "500 ml" -> "GREEN", "EXTRA-LARGE", "500-ML"
// Sirf A-Z, 0-9 aur "-" rakhte hain, taaki barcode (CODE128) aur QR dono mein clean scan ho
export const toSkuSegment = (str = "") =>
  String(str)
    .toUpperCase()
    .trim()
    .replace(/[^A-Z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

// User ke manually type kiye SKU ko bhi clean rakhta hai (uppercase, spaces / special chars nahi)
export const sanitizeSku = (str = "") =>
  String(str)
    .toUpperCase()
    .replace(/\s+/g, "-")
    .replace(/[^A-Z0-9_-]/g, "");

/**
 * Base SKU mein variant ka segment beech mein daalta hai.
 *
 *   SKU-PA-2605-9271 + { color: "Green" }                -> SKU-PA-GREEN-2605-9271
 *   SKU-PA-2605-9271 + { color: "Red", size: "XL" }      -> SKU-PA-RED-XL-2605-9271
 *   ABC123 (custom SKU, auto-format nahi) + { color: "Red" } -> ABC123-RED
 *
 * keys ka order wahi rehta hai jo attributes define karte waqt chuna gaya.
 */
export const buildVariantSku = (baseSku, attrs = {}, keys = []) => {
  const segment = keys
    .map((k) => toSkuSegment(attrs?.[k]))
    .filter(Boolean)
    .join("-");

  const base = String(baseSku || "")
    .trim()
    .toUpperCase();

  if (!segment) return base;
  if (!base) return segment;

  // Step 1 ka auto-generated format: <PREFIX>-YYMM-RAND (e.g. SKU-PA-2605-9271)
  const match = base.match(/^(.+)-(\d{4}-\d{4})$/);
  if (match) return `${match[1]}-${segment}-${match[2]}`;

  // Custom SKU: variant segment end mein lagao
  return `${base}-${segment}`;
};